import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';

import api from 'src/axios';

type Variables = {
  sessionId: string;
  skus: string[];
};

export const useDeleteProductsFromSession = (
  options?: Omit<UseMutationOptions<void, Error, Variables>, 'mutationFn'>,
): UseMutationResult<void, Error, Variables> => {
  return useMutation({
    mutationFn: async ({ sessionId, skus }: Variables) => {
      const { data } = await api.delete(
        `/sales-forecasting-sessions/${sessionId}/products`,
        {
          data: { skus },
        },
      );
      return data;
    },
    ...options,
  });
};
